export default [
  {
    key: 'name',
    label: 'field.name',
    type: 'text',
  },
  {
    key: 'isActive',
    label: 'field.status',
    type: 'radio',
    options: [
      // { text: 'status.invited', value: '2' },
      { text: 'status.active', value: true },
      { text: 'status.inactive', value: false },
    ],
    md: 'auto',
    lg: 'auto',
  },
];
